// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A3D_","importantInfo":"styles_importantInfo__12fs4"};